module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCAxLjUzMDM5TDEuMDYwNjYgMC40Njk3MjdMNS41MzAzMyA0LjkzOTRMMTAgMC40Njk3MjdMMTEuMDYwNyAxLjUzMDM5TDUuNTMwMzMgNy4wNjA3MkwwIDEuNTMwMzlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/navbar/profile-dropdown.svg
// module id = AsOe
// module chunks = 35